import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autocomplete"
export default class extends Controller {
  static targets = ["locality", "input", "turboframe", "results"]
  static values = { url: String, placeholderLocality: String, placeholderProduct: String, placeholderProducer: String }

  connect() {
    // console.log("connect")
  }

  switch(event) {
    // this.disableFrame()
    this.reset(event)

    if (this.localityTarget.value == "locality") {
      this.inputTarget.placeholder = this.placeholderLocalityValue
    } else if (this.localityTarget.value == "product") {
      this.inputTarget.placeholder = this.placeholderProductValue
    } else if (this.localityTarget.value == "producer") {
      this.inputTarget.placeholder = this.placeholderProducerValue
    }
  }

  autocomplete(event) {
    // if (event.isComposing) { return; }
    // console.log(this.localityTarget.value)
    // console.log(this.inputTarget.value)

    if (!this.hasLocalityTarget || this.localityTarget.value == "locality") {
      this.enableFrame()
      // this.turboframeTarget.src = this.urlValue + "?q=" + this.inputTarget.value

      const frame = this.turboframeTarget
      const newSrc = this.urlValue + "?q=" + this.inputTarget.value

      if (this.pending_timeout) {
        clearTimeout(this.pending_timeout)
      }

      this.pending_timeout = setTimeout(() => {
        if (frame.src != newSrc) {
          frame.src = newSrc
        }
      }, 500)
    }
  }

  select(event) {
    // console.log(event.target.innerText)
    this.inputTarget.value = event.target.innerText

    this.disableFrame()
  }

  up(event) {
    this.updateIndex(-1)
  }

  down(event) {
    this.updateIndex(1)
  }

  updateIndex(step) {
    const children = this.resultsTarget.children
    if (children.length > 0) {
      var activeItem = -1
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains("active")) {
          activeItem = i
        }
      }

      var newIndex = activeItem + step
      if (newIndex < 0) {
        newIndex = children.length -1
      }
      if (newIndex > children.length - 1) {
        newIndex = 0
      }
      if (activeItem > -1) {
        children[activeItem].classList.remove("active")
      }
      children[newIndex].classList.add("active")
    }
  }

  confirm(event) {
    const children = this.resultsTarget.children
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains("active")) {
        this.inputTarget.value = children[i].innerText
      }
    }
  }

  reset(event) {
    this.inputTarget.value = ""
    this.disableFrame()
  }

  enableFrame() {
    this.resultsTarget.style.display = "block"
  }

  disableFrame() {
    this.resultsTarget.style.display = "none"
  }

  disconnect() {
  }
}
